import React, { Component } from 'react';
import '../styles/Search.css';

class Search extends Component {

  //TODO: WHAT IS componentWillMount?
  componentWillMount() {
    this.timer = null;
  }
  //<Search searchBook={this.searchBook} updateSearchValue={this.updateSearchValue} searchValue={this.state.searchValue}/>
  //Implemented a timer, after 2000ms from last typing it sends the information to parent
  handleChange = (event) => {
    this.props.updateSearchValue(event.target.value);
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      if (this.props.searchValue.length > 0) this.props.searchBook();
    }, 1000)
  }

  render () {
    return(
      <div className='Search'>
        <div className='SearchBar'>
          <input autoComplete="off" type='text' className='SearchInput' placeholder="Start by searching for your favorite book" name='searchValue' value={this.props.searchValue} onChange={this.handleChange}/>
          <img alt='search button fantasy books' className='SearchBarIcon'src="http://www.endlessicons.com/wp-content/uploads/2012/12/search-icon.png"/>
          
        </div>
        <img className='GoogleLogo' alt='google books api search'src='https://books.google.com/googlebooks/images/poweredby.png'/>
      </div>
    )
  }
}

export default Search;


// WEBPACK FOOTER //
// ./src/components/Search.js